const MODALS = {
  PRODUCTION_SETUP_PRODUCTION: 'PRODUCTION_SETUP_PRODUCTION',
};

export default MODALS;
